import React from 'react';
import FieldCheckbox from '../fields/FieldCheckbox';
import FieldSelect from '../fields/FieldSelect';
import FieldTextarea from '../fields/FieldTextarea';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { currencyDisplay } from '../../_utils';

function CheckoutPaymentSummary(props) {
    const { isLoading, detail, currencyFormat, currencyDisplayCode, locale } = props;
    const {
        DiscountTotal,
        ShippingTotal,
        SubTotal,
        TaxTotal,
        Total,
        DiscountTitle,
        InternalItemID,
        //TaxDataItems,   // deprecated
        TaxSummary,
        HasTaxInclusive,
    } = detail;

    return (
        <React.Fragment>
            <div className='card__header'>
                <h5 className='heading--lv5 heading'>Summary</h5>
            </div>
            <div
                className={`data-table ${isLoading === true &&
                    'data-table--loading'}`}
            >
                <div className='data-table__body'>
                    <div
                        className='data-table__tr data-table__tr--highlight data-table__tr--noborder'
                        role='row'
                    >
                        <div className='data-table__th data-table__th--small'>
                            <span className='data-table__info'>
                                <LocalizedMessage id={'YOUR_PRODUCTS'} />
                            </span>
                        </div>
                        <div className='data-table__th data-table__th--small tx-right'>
                            <span className='data-table__info'>
                                {currencyDisplay(SubTotal, currencyDisplayCode, currencyFormat, locale)}
                            </span>
                        </div>
                    </div>

                    <div
                        className='data-table__tr data-table__tr--noborder'
                        role='row'
                    >
                        <div className='data-table__td data-table__td--small'>
                            <span className='data-table__info'>
                                <LocalizedMessage id={'FIELD.FREIGHT_DELIVERY_OPTION'} />
                            </span>
                        </div>
                        <div className='data-table__td data-table__td--small tx-right'>
                            <span className='data-table__info'>
                                {currencyDisplay(ShippingTotal, currencyDisplayCode, currencyFormat, locale)}
                            </span>
                        </div>
                    </div>

                    {DiscountTotal > 0 && (
                        <div
                            className='data-table__tr data-table__tr--noborder'
                            role='row'
                        >
                            <div className='data-table__td data-table__td--small'>
                                <span className='data-table__info'>
                                    <LocalizedMessage id={'DISCOUNT'} />
                                    {/* {InternalItemID && ` (${InternalItemID})`} */}
                                </span>
                            </div>
                            <div className='data-table__td data-table__td--small tx-right'>
                                <span
                                    className='data-table__info'
                                    style={{ color: 'red' }}
                                >
                                    -
                                    {currencyDisplay(DiscountTotal, currencyDisplayCode, currencyFormat, locale)}
                                </span>
                            </div>
                        </div>
                    )}
                    {TaxSummary.map((TaxDataItem, index) => {
                        // if (TaxDataItem.IsCompound === false) {
                        if (TaxDataItem.Display && TaxDataItem.IsInclusive === false) {
                            return (
                                <div
                                    key={index}
                                    className='data-table__tr data-table__tr--noborder'
                                    role='row'
                                >
                                    <div className='data-table__td data-table__td--small'>
                                        <span className='data-table__info'>
                                            {TaxDataItem.Title}
                                        </span>
                                    </div>
                                    <div className='data-table__td data-table__td--small tx-right'>
                                        <span className='data-table__info'>
                                            {currencyDisplay(TaxDataItem.CalculatedTax, currencyDisplayCode, currencyFormat, locale)}
                                        </span>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className='data-table__footer data-table__footer--small'>
                    <div className='data-table__tr' role='row'>
                        <div className='data-table__th'>
                            <span className='data-table__heading data-table__heading--big'>
                                <LocalizedMessage id={'TOTAL'} />
                            </span>
                        </div>

                        <div className='data-table__th tx-right'>
                            <span className='data-table__heading data-table__heading--big'>
                                {currencyDisplay(Total, currencyDisplayCode, currencyFormat, locale)}
                            </span>
                        </div>
                    </div>
                    {HasTaxInclusive && TaxSummary.map((TaxDataItem, index) => {
                        // if (TaxDataItem.IsCompound === true) {
                        if (TaxDataItem.Display && TaxDataItem.IsInclusive === true) {
                            return (
                                <div
                                    key={index}
                                    className='data-table__tr data-table__tr--noborder'
                                    role='row'
                                >
                                    <div className='data-table__td data-table__td--small'>
                                        <span className='data-table__info'>
                                            {`Included ${TaxDataItem.Title}`}
                                        </span>
                                    </div>
                                    <div className='data-table__td data-table__td--small tx-right'>
                                        <span className='data-table__info'>
                                            {currencyDisplay(TaxDataItem.CalculatedTax, currencyDisplayCode, currencyFormat, locale)}
                                        </span>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        </React.Fragment>
    );
}

export default CheckoutPaymentSummary;
